export class BaseDto {

}
